import moment from "moment";
import { useRef, useState } from "react";

type Result = {
  isStarted: boolean;
  isTimeOut: boolean;
  startCounter: (from: Date, seconds: number) => void;
  reset: () => void;
};

export const useVideoConsultTimeOut = (): Result => {
  const [isStarted, setIsStarted] = useState(false);
  const [isTimeOut, setIsTimeOut] = useState(false);
  const timerId = useRef(null);

  const clearTimer = () => {
    if (timerId.current) {
      clearInterval(timerId.current);
    }
  };

  const startCounter = (from: Date, seconds: number) => {
    setIsStarted(true);
    clearTimer();
    const expectedDate = moment(from).add(seconds, "seconds");
    timerId.current = setInterval(() => {
      if (moment().isAfter(expectedDate)) {
        clearTimer();
        setIsTimeOut(true);
      }
    }, 1000);
  };

  const reset = () => {
    setIsStarted(false);
    setIsTimeOut(false);
    clearTimer();
  };

  return {
    isStarted,
    isTimeOut,
    startCounter,
    reset
  };
};
